module.exports = __webpack_public_path__ + "media/images/logo-otec-achs-36672814e50e3908810e37fe4e2250f3.png";